import axiosClient from "../axiosClient";

export const getSSOlog = async () => {
    return await axiosClient.get('/get_sso_log');
};